import styled from '@emotion/styled';

type StatusProps = {
  bgColor: string;
  textColor: string;
};

export const Status = styled.span<StatusProps>`
  height: 24px;
  background-color: ${({ theme, bgColor }) =>
    bgColor || theme.colors.bgGrayLight};
  color: ${({ theme, textColor }) => textColor || theme.colors.black};
  border-radius: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  padding: 4px 12px;
  line-height: 16px;
`;

export const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

/* The marker sits beside the status rather than replacing it: the status is still true. */
export const ErrorMarker = styled.span`
  color: ${({ theme }) => theme.colors.error};
  font-size: 14px;
  line-height: 1;
  cursor: help;

  /* Reachable by keyboard, and visibly so — the tooltip is the only carrier of the reason. */
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.error};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
